<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VSPSnD/tc-custom/9781398447950.jpg?1705056297922" alt="This image is the cover for the book Sad, Sardonic and Hopeful"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sad, Sardonic and Hopeful
      </h1>
      <p class="bookDescription body article font2">
        <p>After years of being told to write down her sardonic musings, MJ Fuller finally took the plunge. These poems explore the various thoughts that she, and others, have had at various points in life, and are easily read and accessible for all.<br/>Whether you are a poetry novice or a poetry veteran, there is something in these verses for you. The poems of Sad, Sardonic and Hopeful take the reader on a journey through the eyes of the poet. That journey can be happy, sad, comedic, tragic or whimsical, but it’s certainly a journey. A perfect, little, evocative escape from a very manic world.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        MJ Fuller
      </h2>
      
      <p class="authorDescription body article">Professionally trained as an actress, MJ Fuller has always been interested in creative writing. Often, she found herself writing poetry as a way of expressing herself, which was always well received by her peers. Eventually, she decided to take the plunge and put together a manuscript of her work. Sad, Sardonic and Hopeful is her first contribution to the literary world.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?74c2f382